import { i18n } from '@/plugins/i18n'
export const moneyRequestPaymentStatus = {
    INIT: '0',
    SUCCESS: '1',
    FAIL: '2',
    CANCELLED:'3',
    CANCELLED_BY_ADMIN:'4',
    PAID:'5'
}
export const moneyRequestPaymentStatusStr = {
    INIT: i18n.t('money_request.pending'),
    SUCCESS: i18n.t('money_request.succeed_payment'),
    FAIL: i18n.t('money_request.failed_payment'),
    CANCELLED: i18n.t('money_request.cancelled_payment'),
    CANCELLED_BY_ADMIN: i18n.t('money_request.cancelled_by_admin_payment'),
    PAID: i18n.t('money_request.paid'),
    get(status) {
        let status_str = null;
        Object.keys(moneyRequestPaymentStatus).forEach(function (item) {
            if(moneyRequestPaymentStatus[item] === status) {
                status_str = moneyRequestPaymentStatus[item]
            }
        })

        return status_str
    }
}